<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <hr class="mt-4"/>

        <p><b>Memória de Cálculo</b> (CDA / Valor de Base / Honorários)</p>

        <b-row style="max-height: 121px; overflow: auto;">
            <b-col md="4">
                <ul class="memoria mb-0">
                    <li v-for="item in listaItensRefis(1)">
                        <span class="mem-descricao">- CDA {{item.numeroDivida}} - R$ {{item.valorBaseHonorarios | currency}}(VB) -  R$ {{item.valorHonorarios | currency}} ({{item.percentual}}%)</span>
                    </li>
                </ul>
            </b-col>
            <b-col md="4">
                <ul class="memoria mb-0">
                    <li v-for="item in listaItensRefis(2)">
                        <span class="mem-descricao">- CDA {{item.numeroDivida}} - R$ {{item.valorBaseHonorarios | currency}}(VB) -  R$ {{item.valorHonorarios | currency}} ({{item.percentual}}%)</span>
                    </li>
                </ul>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <ul class="memoria mb-0 mt-2">
                    <li>
                        <b>Total: <span class="ml-4">R$ {{ this.requisicao.totalRequisicao | currency }}</span></b>
                    </li>
                </ul>
            </b-col>
        </b-row>

        <b-row style="text-align: right; margin-top: -30px;">
            <b-col md="12">
                <b-button variant="outline-secondary" @click="exportarMemoria">
                    <i class="fas fa-print"></i> Imprimir Memória de Cálculo
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row>
            <b-col md="12">
                <p><b>Opções Complementares</b></p>
                <b-form-checkbox v-model="requisicao.emitirTermoParcelamentoHonorario" id="emitirTermoParcelamentoHonorario"
                                 name="check-button" v-if="requisicao.pagamento != null && requisicao.pagamento.parcelas">
                    Emitir <b>Termo de Parcelamento de Honorários</b>
                </b-form-checkbox>
                <div style="display: flex;">
                    <span>
                        <b-form-checkbox v-model="requisicao.emitirGrpr" id="emitirGrpr" name="check-button" :disabled="requisicao.pagamento == null || requisicao.pagamento.refis">
                            Emitir guia <b>GRPR</b> para a(s) dívida(s) ativa(s) pendente(s)
                        </b-form-checkbox>
                    </span>
                    <span>
                        <i class="fas fa-info-circle fa-12x text-info ml-2" variant="info"
                           v-b-modal.modal-info-grpr
                           v-b-popover.hover.top="'Clique para Detalhes'"></i>
                    </span>
                </div>
            </b-col>
        </b-row>
        <b-row class="px-0 col-md-10">
            <div class="mr-3" style="padding-left: 15px;">
                <b-form-checkbox v-model="requisicao.emitirDocumentacao" id="emitirDocumentacao" name="check-button">
                    Enviar documentação gerada (Termo de parcelamento, memória de cálculo e boleto) ao <b>E-mail</b>
                </b-form-checkbox>
            </div>
            <div class="campo-email col px-0 col">
                <b-form-input v-model="requisicao.emailEnviarDocumentacao" type="text" id="email" maxlength="100"
                              :class="'text-label ' + (!validarEmail ? 'is-invalid' : '')"
                              @keyup="requisicao.emailEnviarDocumentacao = removeSpecialCharactersGeralVirgula(requisicao.emailEnviarDocumentacao)"/>
                <div v-if="!validarEmail" class="invalid-message">Informe ao menos um e-mail válido para o recebimento da documentação gerada!</div>
            </div>
        </b-row>

        <hr class="mt-4"/>

        <b-row>
            <b-col md="4">
                <b-form-group label="Informe o Setor responsável pela Requisição:"
                              label-for="valorindica"
                              class="text-label required">
                    <multiselect
                            class="multiselect-simple mb-3"
                            name="setor"
                            v-model="requisicao.setor"
                            :show-labels="false"
                            :options="dados.setoresFiltrados"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            :internal-search="false"
                            @search-change="searchChangeSetor"
                            placeholder="Selecione"
                            track-by="codSetor"
                            label="nome">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col md="8">
                <b-col>
                    <label for="carregarArq" :class="(!validations.arquivo.valid ? 'is-invalid' : '')">Anexar arquivo à Requisição (ex.: decisão judicial, garantia etc.) (opcional):</label>
                    <b-form-group id="input-group-1" label="" label-for="parcelamento">
                        <b-form-file id="carregarArq" v-model="arquivos" @input="realizarUpload"
                                     :class="!validations.arquivo.valid ? 'is-invalid' : ''"
                                     placeholder="Selecionar um arquivo"
                                     accept="image/png|image/jpeg|image/jpg|text/plain"></b-form-file>
                        <div v-if="!validations.arquivo.valid" class="invalid-message">Tamanho do arquivo ultrapassa o limite definido em 50mb.</div>
                    </b-form-group>
                </b-col>
            </b-col>
        </b-row>

        <b-row v-for="arquivo in requisicao.arquivos">
            <b-col md="4"></b-col>
            <b-col md="6" class="mt-1">
                <a class="link" style="margin-left: 30px;" @click="obterAnexo(arquivo)">
                    {{ arquivo.nomeArquivo }}
                </a>
                <b-button class="ml-2"
                          variant="outline-warning"
                          @click="excluirArquivo(arquivo)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mt-1 align-items-center">
            <div class="px-3">
                <label class="text-bold">Observações:</label>
            </div>
            <div class="col" v-if="!validations.observacao.valid">
                <div class="msg-observacoes mb-1 invalid-feedback d-block">
                    Como houve a edição de valor(es) de CDA na tela anterior, informe a razão ou o processo jud. (CNJ) ou administrativo (SID/NUP) que justificou a alteração!
                </div>
            </div>
        </b-row>
        <b-row class="mb-0">
            <b-col>
                <b-form-textarea
                        id="observacoes"
                        v-model="requisicao.observacoes"
                        size="500"
                        placeholder=""
                        max-rows="10"
                        :class="(!validations.observacao.valid ? 'is-invalid' : '')"
                ></b-form-textarea>
            </b-col>
        </b-row>

        <b-modal
                ref="modal-info-grpr"
                id="modal-info-grpr"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Emitir guia GRPR para a(s) dívida(s) ativa(s) pendente(s)"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            Somente será permitido emitir guia GRPR quando a modalidade de pagamento selecionada na tela anterior não for do tipo REFIS. Para emitir as guias GRPR com os benefícios do REFIS, o contribuinte deverá obtê-las diretamente junto à SEFA.
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-grpr')"> Fechar</b-button>
            </template>
        </b-modal>
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";

    export default {
        props: ['devedor','requisicao'],
        mixins: [ formatarMixins ],
        components: {CompLoading, ModalIncluirDevedor},
        data() {
            return {
                urlApi: null,
                token: null,
                arquivos: [],
                arquivosTemp: [],
                dados: {
                    setores: [],
                    setoresFiltrados: [],
                },
                validations: {
                    observacao: {
                        valid: true
                    },
                    arquivo: { valid: true }
                }
            }
        },
        computed: {
            getTheme() {
                return this.$store.getters.getTheme
            },
            validarEmail() {
                if(this.requisicao != null && this.requisicao.emitirDocumentacao && (this.verificarValorVazio(this.requisicao.emailEnviarDocumentacao)
                    || !this.requisicao.emailEnviarDocumentacao.includes('@'))) {
                    return false;
                }

                return true;
            },
        },
        methods: {
            validarEmailPreenchido() {
                if(this.requisicao != null && this.requisicao.emitirDocumentacao && (this.verificarValorVazio(this.requisicao.emailEnviarDocumentacao)
                    || !this.requisicao.emailEnviarDocumentacao.includes('@'))) {
                    return false;
                }

                return true;
            },
            nomeDevedorFormatado() {
                return this.requisicao.devedor.nome +
                    (this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                        this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                    this.requisicao.devedor.documento + ')';
            },
            listaItensRefis(part){
                let filterItems = [];
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    if(this.requisicao.pagamento && !this.requisicao.pagamento.refis || this.requisicao.cdas[i].refisAtivo == 'S') {
                        filterItems.push(this.requisicao.cdas[i]);
                    }
                }

                if(filterItems.length <= 5) {
                    return part == 1 ? filterItems : [];
                }

                if(filterItems.length < 10) {
                    let secondPart = filterItems.length - 5;
                    return part == 1 ? filterItems.slice(0, 5) : filterItems.slice(-secondPart);
                }

                let half = Math.ceil(filterItems.length / 2);

                return part == 1 ? filterItems.slice(0, half) : filterItems.slice(-half);
            },
            async obterAnexo(anexo) {
                if(anexo.base64 == null && anexo.codAnexo != null) {
                    await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        },
                    }).then(response => {
                        if(!response.data || response.data == null){
                            this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                    }).catch((error) => {
                        this.exibirErro(error)
                    });
                } else {
                    var a = document.createElement("a");
                    a.href = anexo.base64;
                    a.download = anexo.nomeArquivo;
                    a.click();
                }
            },
            validarObservacao() {
                this.validations.observacao.valid = true;
                if(this.requisicao.houveAlteracao && this.verificarValorVazio(this.requisicao.observacoes)) {
                    this.validations.observacao.valid = false;
                }

                return this.validations.observacao.valid;
            },
            async exportarMemoria() {
                let filterItems = [];
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    if(!this.requisicao.pagamento.refis || this.requisicao.cdas[i].refisAtivo == 'S') {
                        filterItems.push(this.requisicao.cdas[i]);
                    }
                }

                let requisicaoTemp = {
                    ... this.requisicao,
                    cdas: filterItems
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/honorariosProtesto/exportarMemoriaCalculo`, requisicaoTemp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'MemoriaCalculo.pdf';
                        link.click();
                    }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },
            realizarUpload(arquivo) {
                this.validations.arquivo.valid = true;
                if(arquivo != null) {
                    let arquivoConvertido = null
                    if ((arquivo.size / 1024) / 1024 > 50.0) {
                        this.validations.arquivo.valid = false;
                    } else {
                        var reader = new FileReader()
                        reader.onload = function (e) {
                            arquivoConvertido = {
                                nomeArquivo: arquivo.name,
                                base64: e.target.result
                            }
                        }
                        reader.readAsDataURL(arquivo)
                        reader.onloadend = () => {
                            this.$emit('executeUpload', arquivoConvertido);
                            this.arquivos = [];
                            this.arquivosTemp.push(arquivoConvertido);
                        }
                    }
                }
            },
            excluirArquivo(arquivo) {
                const index = this.arquivosTemp.indexOf(arquivo);
                this.arquivosTemp.splice(index, 1);
                this.$emit('excluirArquivo', arquivo);
            },
            atualizarSetor() {
                if(this.requisicao.setor != null && this.requisicao.setor.codSetor != null) {
                    for(var i = 0; i < this.dados.setores.length; i++) {
                        if(this.requisicao.setor.codSetor == this.dados.setores[i].codSetor) {
                            this.requisicao.setor = this.dados.setores[i];
                        }
                    }
                }
            },
            async listarSetores() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarSetores`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.setores = response.data;
                    this.dados.setoresFiltrados = response.data;

                    this.atribuirSetorPadrao();
                })
            },
            atribuirSetorPadrao() {
                let userData = JSON.parse(this.$store.getters.getUser);
                if (userData.groups) {
                    for (let i = 0; i < userData.groups.length; i++) {
                        if(userData.groups[i] == 'SFEPGE-ADMINISTRATIVO') {
                            for (let j = 0; j < this.dados.setores.length; j++) {
                                if(this.dados.setores[j].nome.includes("Coordenadoria de Assuntos Fiscais")) {
                                    this.requisicao.setor = this.dados.setores[j];
                                }
                            }
                        }
                    }
                }
            },
            async obterAnexo(anexo) {
                if(anexo.base64 == null && anexo.codAnexo != null) {
                    await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        },
                    }).then(response => {
                        if(!response.data || response.data == null){
                            this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                    }).catch((error) => {
                        this.exibirErro(error)
                    });
                } else {
                    var a = document.createElement("a");
                    a.href = anexo.base64;
                    a.download = anexo.nomeArquivo;
                    a.click();
                }
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.listarSetores();
        }
    }
</script>

<style scoped>
    .memoria {
        list-style: none;
    }

    .mem-descricao {
        text-align: right;
    }

    .campo-email {
        margin: -.5rem 0;
    }

    .mem-total {
        text-align: right;
        font-weight: 700;
    }
</style>